// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"723":"5f6b9237","949":"5d241fea"}[chunkId] + ".chunk.js";
};